import iReducer from 'renderer/Global/State/reducerInterface';
import './style.css';
import { Menu, Award, Settings, HelpCircle, Save } from 'react-feather';
import { setItem } from 'renderer/Global/State/InitData/localStorage/localStorage';
import State from 'renderer/Global/State/State';

interface iNav extends iReducer {
  toggleNav: CallableFunction;
  toggleManagement: CallableFunction;
  toggleSettings: CallableFunction;
  togglePlayerDetails: CallableFunction;
}

export default function Nav({
  state,
  dispatch,
  toggleNav,
  toggleManagement,
  toggleSettings,
  togglePlayerDetails,
}: iNav) {
  return (
    <div className="navBar">
      <div className="navLeft">
        {/* Unused currently */}
        <Menu className="navIcon" size={26} onClick={() => toggleNav()} />
      </div>
      <div
        id="navManagement"
        className="navManagement"
        onClick={() => toggleManagement()}
      >
        Management
      </div>
      <div className="navRight">
        <Save
          className="navIcon changeLogIcon"
          size={26}
          onClick={() => setItem<State>('spectreSaveData', state)}
        />
        <Award
          id="navAward"
          className="navIcon achievementsIcon"
          size={26}
          onClick={() => togglePlayerDetails()}
        />
        <HelpCircle id="navHelpCirle" className="navIcon helpIcon" size={26} />
        <Settings
          id="navSettings"
          className="navIcon settingsIcon"
          size={26}
          onClick={() => toggleSettings()}
        />
      </div>
    </div>
  );
}
